// extracted by mini-css-extract-plugin
module.exports = {"title":"_559fe62","dot":"_c247c9b"};